module.exports = {"440507001":"金霞街道","440507003":"珠池街道","440507004":"新津街道","440507005":"鸥汀街道","440507008":"龙祥街道","440507009":"外砂街道","440507010":"龙华街道","440507011":"新溪街道","440507012":"新海街道","440507013":"龙腾街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440507.json
// module id = 2104
// module chunks = 0